import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { api } from "../api";

// The bell in the top bar (AppLayout's user menu): a link to /notifications with the number of
// unread notifications. It asks GET /api/me/notifications/unread-count when a page opens and
// every POLL_MS after; a failed request leaves it as it was (the bell is never an error).
// The NotificationsPage announces "notifications-changed" after marking some read, so the
// count follows at once.

export const POLL_MS = 60000;
export const CHANGED_EVENT = "unio:notifications-changed";

export default function NotificationBell() {
  const [unread, setUnread] = useState(0);
  const location = useLocation();

  useEffect(() => {
    let live = true;
    const load = () => api.get("/me/notifications/unread-count")
      .then(r => { if (live && typeof r?.unread === "number") setUnread(r.unread); })
      .catch(() => { /* keep the last count */ });
    load();
    const timer = setInterval(load, POLL_MS);
    window.addEventListener(CHANGED_EVENT, load);
    return () => { live = false; clearInterval(timer); window.removeEventListener(CHANGED_EVENT, load); };
  }, [location.pathname]);

  const label = unread ? `Notifications, ${unread} unread` : "Notifications";
  return (
    <Link to="/notifications" aria-label={label} title={label}
          style={{ position: "relative", color: "#ffffff", textDecoration: "none", fontSize: 13, fontWeight: 500,
                   padding: "5px 10px", borderRadius: 6, background: "rgba(0,0,0,0.18)",
                   display: "inline-flex", alignItems: "center", gap: 6 }}>
      <svg aria-hidden="true" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor"
           strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
        <path d="M13.73 21a2 2 0 0 1-3.46 0" />
      </svg>
      {/* Only in the open phone menu, where the bell is a row of its own (data-menu-only). */}
      <span data-menu-only aria-hidden="true">Notifications</span>
      {unread > 0 && (
        <span aria-hidden="true" data-unread
              style={{ background: "#ffffff", color: "#7f1d1d", borderRadius: 999, fontSize: 11, fontWeight: 700,
                       minWidth: 18, padding: "1px 5px", textAlign: "center" }}>
          {unread > 99 ? "99+" : unread}
        </span>
      )}
    </Link>
  );
}
